module.exports = __webpack_public_path__ + "media/images/home/step_template_4th-611a01e007c5ee49427bdabc4547a4e1.svg";